(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    

(() => {
  'use strict';

  const RUNTIME_ATTRIBUTE =
    'data-footer-localization-runtime-ready';

  if (
    document.documentElement.hasAttribute(
      RUNTIME_ATTRIBUTE
    )
  ) {
    return;
  }

  document.documentElement.setAttribute(
    RUNTIME_ATTRIBUTE,
    ''
  );

  const boundFooters =
    new WeakSet();


  const getFooters = (
    root = document
  ) => {
    const footers = [];

    if (
      root instanceof Element &&
      root.matches(
        '[data-footer]'
      )
    ) {
      footers.push(
        root
      );
    }

    footers.push(
      ...(
        root.querySelectorAll?.(
          '[data-footer]'
        ) || []
      )
    );

    return footers;
  };


  const submitLocalizationForm = (
    select
  ) => {
    const form =
      select.form ||
      select.closest(
        'form'
      );

    if (!form) {
      return;
    }

    if (
      typeof form.requestSubmit ===
      'function'
    ) {
      form.requestSubmit();

      return;
    }

    form.submit();
  };


  const bindFooter = (
    footer
  ) => {
    if (
      boundFooters.has(
        footer
      )
    ) {
      return;
    }

    boundFooters.add(
      footer
    );

    footer.classList.add(
      'footer--enhanced'
    );

    footer
      .querySelectorAll(
        '[data-localization-select]'
      )
      .forEach(
        (select) => {
          select.addEventListener(
            'change',
            () => {
              submitLocalizationForm(
                select
              );
            }
          );
        }
      );
  };


  const initialize = (
    root = document
  ) => {
    getFooters(root).forEach(
      bindFooter
    );
  };


  const boot = () => {
    initialize(
      document
    );
  };


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true,
      }
    );
  } else {
    boot();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialize(
        event.target
      );
    }
  );
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    'use strict';

    const runtimeRoot = document.documentElement;

    if (runtimeRoot.dataset.productRecommendationsRuntimeReady === 'true') {
      return;
    }

    runtimeRoot.dataset.productRecommendationsRuntimeReady = 'true';

    class ProductRecommendations {
      constructor() {
        this.observer = null;
        this.controllers = new Map();

        this.handleIntersect =
          this.handleIntersect.bind(this);

        this.handleSectionLoad =
          this.handleSectionLoad.bind(this);

        this.handleSectionUnload =
          this.handleSectionUnload.bind(this);
      }

      init() {
        if ('IntersectionObserver' in window) {
          this.observer =
            new IntersectionObserver(
              this.handleIntersect,
              {
                rootMargin: '500px 0px'
              }
            );
        }

        this.initialize(document);

        document.addEventListener(
          'shopify:section:load',
          this.handleSectionLoad
        );

        document.addEventListener(
          'shopify:section:unload',
          this.handleSectionUnload
        );
      }

      getContainers(root = document) {
        const containers = [];

        if (
          root instanceof Element &&
          root.matches('[data-product-recommendations]')
        ) {
          containers.push(root);
        }

        if (
          root?.querySelectorAll
        ) {
          containers.push(
            ...root.querySelectorAll(
              '[data-product-recommendations]'
            )
          );
        }

        return [
          ...new Set(containers)
        ];
      }

      initialize(root = document) {
        this.getContainers(root)
          .forEach(
            (container) => {
              if (
                container.dataset.recommendationsBound === 'true'
              ) {
                return;
              }

              container.dataset.recommendationsBound = 'true';

              if (
                container.hasAttribute(
                  'data-recommendations-loaded'
                )
              ) {
                return;
              }

              if (this.observer) {
                this.observer.observe(container);
              } else {
                this.load(container);
              }
            }
          );
      }

      handleIntersect(entries) {
        entries.forEach(
          (entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            this.observer?.unobserve(
              entry.target
            );

            this.load(
              entry.target
            );
          }
        );
      }

      async load(container) {
        const url =
          container.dataset.url;

        if (!url) {
          container.remove();

          return;
        }

        const existingController =
          this.controllers.get(
            container
          );

        existingController?.abort();

        const controller =
          new AbortController();

        this.controllers.set(
          container,
          controller
        );

        container.setAttribute(
          'aria-busy',
          'true'
        );

        try {
          const response =
            await fetch(
              url,
              {
                headers: {
                  Accept: 'text/html'
                },

                cache: 'no-store',

                credentials:
                  'same-origin',

                signal:
                  controller.signal
              }
            );

          if (!response.ok) {
            throw new Error(
              `Unable to load product recommendations (${response.status}).`
            );
          }

          const html =
            await response.text();

          const parsed =
            new DOMParser()
              .parseFromString(
                html,
                'text/html'
              );

          const replacement =
            parsed.querySelector(
              '[data-product-recommendations]'
            );

          if (
            !replacement ||
            !replacement.hasAttribute(
              'data-recommendations-loaded'
            )
          ) {
            container.remove();

            return;
          }

          replacement.dataset.recommendationsBound =
            'true';

          container.replaceWith(
            replacement
          );

          document.dispatchEvent(
            new CustomEvent(
              'theme:product-recommendations:loaded',
              {
                bubbles: true,

                detail: {
                  section:
                    replacement
                }
              }
            )
          );
        } catch (error) {
          if (
            error?.name ===
            'AbortError'
          ) {
            return;
          }

          console.error(
            '[Product Recommendations] Unable to load recommendations.',
            error
          );

          container.remove();
        } finally {
          container.removeAttribute(
            'aria-busy'
          );

          this.controllers.delete(
            container
          );
        }
      }

      handleSectionLoad(event) {
        this.initialize(
          event.target
        );
      }

      handleSectionUnload(event) {
        const containers =
          this.getContainers(
            event.target
          );

        containers.forEach(
          (container) => {
            this.observer?.unobserve(
              container
            );

            this.controllers
              .get(container)
              ?.abort();

            this.controllers.delete(
              container
            );
          }
        );
      }
    }

    const recommendations =
      new ProductRecommendations();

    const init = () => {
      recommendations.init();
    };

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        init,
        {
          once: true
        }
      );
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
